import { PageLoading } from '@/components/page-loading'
import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'
import ReportTask from '@/pages/evaluation/report-task/index'
import { useGetMenuList } from '@/pages/login/util'

interface MenuItem {
  key: string
  label: string
  component: React.ReactNode
  show?: boolean
  name?: string
  id?: string
}

export const ReportTaskLayout = () => {
  const [getMenuList, menuList] = useGetMenuList()
  const [menuListData, setMenuListData] = useState<MenuItem[]>([])

  useEffect(() => {
    getMenuList()
      .then(res => {
        setMenuListData(
          res?.data?.items
            ?.filter(
              item =>
                item.name !== '运维管理' &&
                item.report_auth === 1 &&
                item.id !== '10' &&
                item.id !== '8',
            )
            .map(item => ({
              key: item.id,
              label: item.name,
              id: item.id,
              component: <ReportTask id={item.id} />,
            }))
            .sort((a, b) => {
              if (a.label === '邮箱收集') return 1
              if (b.label === '邮箱收集') return -1
              return 0
            }),
        )
        console.log('menuListData', menuListData)
      })
      .catch(_ => {})
  }, [])

  return (
    <ContentLayout menuList={menuListData}>
      <Suspense fallback={<PageLoading />}>
        <Outlet />
      </Suspense>
    </ContentLayout>
  )
}
